import * as React from 'react';
import { CheckboxField } from '@cian/components';

import { DropdownField } from '../../../components/dropdownField';

import { ELayoutType, IJsonQuery } from '../../../../../../../json_query';

import { InlineParam } from '../../../markup';

interface ILayoutProps {
  isRoomTypeAvailable: boolean;
  isWithLayoutAvailable: boolean;
  jsonQuery: IJsonQuery;

  onLayoutChanged(value: ELayoutType): void;
  onWithLayoutChanged(value: boolean): void;
}

export const Layout: React.StatelessComponent<ILayoutProps> = props => {
  const { jsonQuery } = props;

  const withLayout = jsonQuery.with_layout && jsonQuery.with_layout.value;
  const roomType = jsonQuery.room_type && jsonQuery.room_type.value;

  return (
    <>
      {props.isRoomTypeAvailable && (
        <InlineParam>
          <DropdownField
            value={roomType || ELayoutType.Any}
            onValueChange={(value: ELayoutType) => props.onLayoutChanged(value)}
            values={[
              { value: ELayoutType.Any, label: 'Любая' },
              { value: ELayoutType.UnitedRooms, label: 'Смежная' },
              { value: ELayoutType.IsolatedRooms, label: 'Изолированная' },
            ]}
          />
        </InlineParam>
      )}
      {props.isWithLayoutAvailable && (
        <InlineParam>
          <CheckboxField
            onValueChange={props.onWithLayoutChanged}
            value={withLayout || false}
            label="Схема планировки"
          />
        </InlineParam>
      )}
    </>
  );
};
